import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import AppointmentComments from '../Appointment/AppointmentComments';
import StaticTextInput from '../StaticTextInput';
import UserSearchNew from '../Search/UserSearchNew';
import customerActions from '../../Actions/customerActions';
import commonActions from '../../Actions/commonActions';
import { bindActionCreators } from 'redux';
import TextInput from '../TextInput';
import StandardModal, {ModalSize} from "../Fundamentals/Modal/StandardModal";
import {FormSearchNew} from "../Search/FormSearch";

const AttendedOnboardingDetails = ({ t, attendedOnboardingForm, customer, commonActions, customerActions }) => {
    const vbCustomer = customer?.vbCustomer;
    
    const onFieldChange = (field, value) => {
        commonActions.changeMultiFormField("attendedOnboardingForm", field, value);
    }
    const onSaveForm = () => {
        customerActions.updateOnboardingDetails(attendedOnboardingForm);
    }

    const onModalClose = () => {
        commonActions.cancelFormEditing("attendedOnboardingForm");
    }

    const onboarding = attendedOnboardingForm?.data || {};
    return (<StandardModal title={"Attended onboarding details"} sixe={ModalSize.X_LARGE} onClose={onModalClose} onSubmit={onSaveForm} isLoading={!attendedOnboardingForm}>
        <div className="form">
            <fieldset className="col-sm-12">
                <FormSearchNew label={t('attendedonboardingdetails.assignto')}>
                    <UserSearchNew onChange={(user) => onFieldChange('assignee', user.email || '')} defaultSelected={onboarding.assignedName} />
                </FormSearchNew>
                <StaticTextInput label={t('attendedonboardingdetails.service')} value={onboarding.serviceName} />
                <StaticTextInput label={t('attendedonboardingdetails.contactperson')} value={onboarding.contactPerson} />
                <StaticTextInput label={t('attendedonboardingdetails.email')} value={vbCustomer?.contactPerson?.email} />
                <StaticTextInput label={t('attendedonboardingdetails.phone')} value={vbCustomer?.contactPerson?.phoneNumber} />
                <AppointmentComments comments={onboarding.allComments} />
                <TextInput label={t('attendedonboardingdetails.createcomment')} maxAmountOfCharacters={4000} onChange={onFieldChange.bind(this, 'comment')} value={onboarding.comment || ""} multiline={true} />
            </fieldset>
        </div>
    </StandardModal>);
}


function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        attendedOnboardingForm: state.CommonReducer.forms && state.CommonReducer.forms.attendedOnboardingForm,
    }
}
function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AttendedOnboardingDetails));